var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 362,
    viewBox: "0 0 344 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8368_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 362C192.483 362 248 357.971 248 353C248 348.029 192.483 344 124 344C55.5167 344 0 348.029 0 353C0 357.971 55.5167 362 124 362Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.697 84.3308H206.747V30.9154C206.747 26.8555 205.948 22.8354 204.394 19.0846C202.84 15.3337 200.563 11.9256 197.693 9.05489C194.822 6.18412 191.414 3.90691 187.663 2.35327C183.912 0.799632 179.892 -1.28067e-05 175.832 1.53832e-10H62.6641C58.6043 -9.60495e-06 54.5841 0.799634 50.8333 2.35328C47.0825 3.90692 43.6744 6.18413 40.8036 9.05489C37.9328 11.9257 35.6556 15.3338 34.1019 19.0846C32.5483 22.8354 31.7487 26.8555 31.7487 30.9154V323.957C31.7487 328.016 32.5483 332.037 34.1019 335.787C35.6556 339.538 37.9328 342.946 40.8036 345.817C43.6744 348.688 47.0825 350.965 50.8333 352.519C54.5841 354.072 58.6043 354.872 62.6641 354.872H175.832C179.892 354.872 183.912 354.072 187.663 352.519C191.414 350.965 194.822 348.688 197.693 345.817C200.563 342.946 202.84 339.538 204.394 335.787C205.948 332.036 206.747 328.016 206.747 323.957V122.353H208.697V84.3308Z",
    fill: "#203155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.079 8.04311H162.307C162.986 9.70861 163.246 11.5156 163.062 13.3049C162.879 15.0943 162.258 16.811 161.255 18.3039C160.251 19.7968 158.896 21.0201 157.309 21.8659C155.721 22.7118 153.95 23.1543 152.152 23.1544H87.3192C85.5205 23.1543 83.7494 22.7118 82.162 21.8659C80.5746 21.0201 79.2195 19.7968 78.2162 18.3039C77.2129 16.811 76.5921 15.0943 76.4086 13.3049C76.225 11.5156 76.4844 9.7086 77.1637 8.04309H63.3665C60.3346 8.04309 57.3325 8.64025 54.5314 9.80049C51.7303 10.9607 49.1852 12.6613 47.0413 14.8052C44.8975 16.949 43.1969 19.4941 42.0366 22.2952C40.8764 25.0963 40.2792 28.0985 40.2792 31.1303V323.742C40.2792 326.773 40.8764 329.776 42.0366 332.577C43.1969 335.378 44.8975 337.923 47.0413 340.067C49.1852 342.211 51.7303 343.911 54.5314 345.071C57.3325 346.232 60.3346 346.829 63.3665 346.829H177.079C180.111 346.829 183.113 346.232 185.914 345.071C188.715 343.911 191.26 342.211 193.404 340.067C195.548 337.923 197.249 335.378 198.409 332.577C199.569 329.776 200.166 326.773 200.166 323.742V31.1304C200.166 28.0985 199.569 25.0963 198.409 22.2952C197.249 19.4942 195.548 16.949 193.404 14.8052C191.26 12.6613 188.715 10.9608 185.914 9.80051C183.113 8.64027 180.111 8.04311 177.079 8.04311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.032 86.6504H95.7266V90.3934H136.032V86.6504Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.976 99.5985H95.7266V103.342H165.976V99.5985Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.907 112.547H95.7266V116.29H165.907V112.547Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3736 86.7061H57.4298V116.65H87.3736V86.7061Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.032 165.253H95.7266V168.996H136.032V165.253Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.976 178.201H95.7266V181.944H165.976V178.201Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.907 191.149H95.7266V194.892H165.907V191.149Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3736 165.308H57.4298V195.252H87.3736V165.308Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.032 243.855H95.7266V247.598H136.032V243.855Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.976 256.804H95.7266V260.547H165.976V256.804Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.907 269.752H95.7266V273.495H165.907V269.752Z",
    fill: "#D6DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3736 243.911H57.4298V273.855H87.3736V243.911Z",
    fill: "#00BFA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8368_536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343.278,
    height: 361.62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessGrowth);
export default __webpack_public_path__ + "static/media/business_growth.604d1e9f7242e0a0813a896d9cff21ea.svg";
export { ForwardRef as ReactComponent };